// extracted by mini-css-extract-plugin
export var productImage = "_vr-0";